import type { AddressComponent } from '../api/handlers/resources/externalServices/response';
import { webConfig } from './webConfig';

export const DISABLE_CAPTCHA = webConfig.disableCaptcha;

// Google has the worst docs and inconsistencies in their APIs.
// Their JS package returns snake_case.
const getStupidGoogleNames = (
    element: AddressComponent | google.maps.GeocoderAddressComponent,
): { longName: string; shortName: string } => ({
    longName: (element as any).longName || (element as any).long_name,
    shortName: (element as any).shortName || (element as any).short_name,
});

export const getAddressComponents = (
    addresses: AddressComponent[] | google.maps.GeocoderAddressComponent[],
) => {
    const result = {
        streetNumber: '',
        route: '',
        zip: '',
        city: '',
        state: '',
        country: '',
        countryCode: '',
    };
    addresses.forEach((element) => {
        const { longName, shortName } = getStupidGoogleNames(element);
        if (element.types.includes('locality')) {
            result.city = longName;
        } else if (element.types.includes('administrative_area_level_1')) {
            result.state = shortName;
        } else if (element.types.includes('country')) {
            result.country = longName;
            result.countryCode = shortName;
        } else if (element.types.includes('postal_code')) {
            result.zip = longName;
        } else if (element.types.includes('street_number')) {
            result.streetNumber = longName;
        } else if (element.types.includes('route')) {
            result.route = longName;
        }
    });
    return result;
};
